import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { lettersAPI, errText, openBlob } from '../lib/lettersAPI';
import { ClientAuthorityCard } from '../components/clearance/ClientAuthorityCard';

export default function MyLetters() {
  const [rows, setRows] = useState(null);
  useEffect(() => { lettersAPI.myLetters().then(setRows).catch(() => setRows([])); }, []);
  return (
    <div className="mx-auto max-w-3xl space-y-4 p-6" data-testid="my-letters-page">
      <h1 className="text-3xl font-bold" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>My letters</h1>
      <ClientAuthorityCard />
      {rows?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="my-letters-empty">No letters have been issued to you yet.</p>}
      {(rows || []).map((r) => (
        <Card key={r.id} data-testid={`my-letter-${r.id}`}><CardContent className="flex items-center gap-3 p-4">
          <FileText className="h-5 w-5 text-primary" />
          <div className="flex-1"><p className="font-medium">{r.template_name}</p><p className="text-xs text-muted-foreground">{r.reference} · issued {new Date(r.issued_at).toLocaleDateString('en-AU')}</p></div>
          <Button size="sm" variant="outline" onClick={async () => { try { openBlob(await lettersAPI.myLetterBlob(r.id)); } catch (e) { toast.error(errText(e)); } }} data-testid={`my-letter-open-${r.id}`}>Open PDF</Button>
        </CardContent></Card>))}
    </div>
  );
}
